export const regexes = {
  spokRegex: /^spok\..*$/,
  spokArrayElementsRegex: /^spok\.arrayElements\((.*)\)$/,
  spokGeRegex: /^spok.ge\((.*)\)$/,
  spokGtRegex: /^spok.gt\((.*)\)$/,
  spokLeRegex: /^spok.le\((.*)\)$/,
  spokLtRegex: /^spok.lt\((.*)\)$/,
  spokNeRegex: /^spok.ne\((.*)\)$/,
  spokSLRegex: /^spok.stringLength\((.*)\)$/,
  spokRangeRegex: /^spok\.range\((\d*),\s?(\d*)\)$/,
  spokTestRegex: /^spok\.test\((.*)\)$/,
  spokTypeRegex: /^spok\.type\((.*)\)$/,
};
